import { useEffect, useState } from "react";
import Mapa from "./mapa";

export default function Ponto() {

  const [location, setLocation] = useState(null);
  const [foto, setFoto] = useState(null);
  const [pontos, setPontos] = useState([]);
  const [modal, setModal] = useState(false);
  const [tipo, setTipo] = useState(null);
  const [loading, setLoading] = useState(false);

  const [mostrandoTodos, setMostrandoTodos] = useState(false);
const [carregandoMais, setCarregandoMais] = useState(false);

    const user = JSON.parse(localStorage.getItem("usuario"));

    console.log(user)


  useEffect(() => {
    carregarLocalizacao();
    carregarPontos();
  }, []);

  function carregarLocalizacao() {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocation({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude
        });
      }
    );
  }

  // FUNÇÕES NOVAS ADICIONADAS
function mostrarMaisRegistros() {
  setCarregandoMais(true);
  
  // Simula um pequeno delay para mostrar o efeito de loading
  setTimeout(() => {
    setMostrandoTodos(true);
    setCarregandoMais(false);
  }, 300);
}


// LÓGICA PARA MOSTRAR APENAS 6 REGISTROS INICIALMENTE
const pontosParaMostrar = mostrandoTodos 
  ? pontos 
  : pontos.slice(0, 6);

  async function carregarPontos() {
    const res = await fetch(
      `https://zoomimpressaodigital.com.br/pontozoom/api/listar_pontos.php?user=${user.id}`
    );
    const lista = await res.json();
    setPontos(lista);
  }

  function selecionarFoto(e) {
    setFoto(e.target.files[0]);
  }

  async function salvarPonto() {

    if (!location || !foto) return alert("Dados faltando");

    setLoading(true);

    const formData = new FormData();
    formData.append("user", user.id);
    formData.append("tipo", tipo);
    formData.append("latitude", location.latitude);
    formData.append("longitude", location.longitude);
    formData.append("foto", foto);
    formData.append("token", localStorage.getItem("token"));

    await fetch(
      "https://zoomimpressaodigital.com.br/pontozoom/api/registrar_ponto.php",
      {
        method: "POST",
        body: formData
      }
    );

    setLoading(false);
    setModal(false);
    setFoto(null);
    carregarPontos();
  }

  return (
    <div className="container">

      <header className="header">
        <h1 className="titulo">📍 Registro de Ponto</h1>
        <p className="subtitulo-header">Olá, <strong>{user.nome}!</strong> Registre sua entrada e saída com geolocalização</p>
      </header>

      {location && (
        <div className="mapa-box">
          <div className="mapa-header">
            <span className="localizacao-icon">📍</span>
            <span>Sua localização atual</span>
          </div>
          <Mapa latitude={location.latitude} longitude={location.longitude}/>
        </div>
      )}

      <div className="botoes">
        <button
          className="btn entrada"
          onClick={() => { setTipo("entrada"); setModal(true); }}
        >
          <span className="btn-icon">🟢</span>
          Registrar Entrada
        </button>

        <button
          className="btn saida"
          onClick={() => { setTipo("saida"); setModal(true); }}
        >
          <span className="btn-icon">🔴</span>
          Registrar Saída
        </button>
      </div>

      <div className="secao-registros">
        <div className="secao-header">
          <h2 className="subtitulo">📋 Últimos Registros</h2>
          <span className="contador">{pontos.length} registros</span>
        </div>

        <div className="lista">
          {pontosParaMostrar.length > 0 ? (
            pontosParaMostrar.map(p => (
              <div className="card" key={p.id}>
                <div className="card-header">
                  <span className={`badge ${p.tipo === 'entrada' ? 'badge-entrada' : 'badge-saida'}`}>
                    {p.tipo.toUpperCase()}
                  </span>
                  <span className="data">{new Date(p.data_hora).toLocaleDateString()}</span>
                </div>
                <p className="hora">{new Date(p.data_hora).toLocaleTimeString()}</p>
              </div>
            ))
          ) : (
            <div className="sem-registros">
              <span>📭</span>
              <p>Nenhum registro encontrado</p>
            </div>
          )}
        </div>


 {pontos.length > 6 && (
   <div className="controles-registros">
  <button 
          className="btn-confirmar"
          onClick={mostrarMaisRegistros}
          disabled={carregandoMais}
        >
          {carregandoMais ? (
            <>
              <span className="loading-spinner-small"></span>
              Carregando...
            </>
          ) : (
            <>
              Mostrar Mais ({pontos.length - 6} restantes)
            </>
          )}
        </button>
        </div>
 )}

      </div>

      {/* MODAL */}
      {modal && (
        <div className="modal-bg">
          <div className="modal">
            <div className="modal-header">
              <h3>📷 Tirar foto</h3>
              <p>Confirme sua {tipo} com uma foto</p>
            </div>

            <label className="upload-area">
              <input
                type="file"
                accept="image/*"
                capture
                onChange={selecionarFoto}
                className="file-input"
              />
              <div className="upload-content">
                <span className="upload-icon">📸</span>
                <span>Clique para tirar foto</span>
              </div>
            </label>

            {foto && (
              <div className="preview-container">
                <img
                  className="preview"
                  src={URL.createObjectURL(foto)}
                  alt="Preview"
                />
                <div className="preview-overlay">
                  <span>✅ Foto selecionada</span>
                </div>
              </div>
            )}

            <div className="modal-botoes">
              <button 
                className="btn-confirmar" 
                onClick={salvarPonto} 
                disabled={loading || !foto}
              >
                {loading ? (
                  <>
                    <span className="loading-spinner"></span>
                    Salvando...
                  </>
                ) : "Confirmar Registro"}
              </button>

              <button 
                className="btn-cancelar" 
                onClick={() => { setModal(false); setFoto(null); }}
                disabled={loading}
              >
                Cancelar
              </button>
            </div>

          </div>
        </div>
      )}

      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
          .controles-registros {
            display: flex;
            flex-direction: column;
            gap: 15px;
            align-items: center;
            padding-top: 15px;
            border-top: 1px solid rgba(255, 140, 66, 0.2);
          }

        .container {
          min-height: 100vh;
          color: #fff;
          font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
          padding: 20px;
          max-width: 600px;
          margin: 0 auto;
        }

        .header {
          text-align: center;
          margin-bottom: 30px;
          padding-top: 10px;
        }

        .titulo {
          font-size: 2.2rem;
          background: linear-gradient(45deg, #FF6B00, #FF8C42);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 8px;
          font-weight: 800;
          letter-spacing: -0.5px;
        }

        .subtitulo-header {
          color: #888;
          font-size: 0.95rem;
          font-weight: 400;
        }

        .mapa-box {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 20px;
          overflow: hidden;
          margin-bottom: 25px;
          border: 1px solid rgba(255, 140, 66, 0.2);
          backdrop-filter: blur(10px);
        }

        .mapa-header {
          padding: 15px 20px;
          background: rgba(255, 107, 0, 0.1);
          border-bottom: 1px solid rgba(255, 140, 66, 0.3);
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 0.9rem;
          color: #FF8C42;
        }

        .botoes {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-bottom: 30px;
        }

        .btn {
          padding: 18px 15px;
          border: none;
          border-radius: 15px;
          font-size: 1rem;
          cursor: pointer;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        }

        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
        }

        .btn:active {
          transform: translateY(0);
        }

        .entrada {
          background: linear-gradient(135deg, #00b894, #00a085);
          color: white;
        }

        .saida {
          background: linear-gradient(135deg, #e74c3c, #c0392b);
          color: white;
        }

        .btn-icon {
          font-size: 1.2rem;
        }

        .secao-registros {
          background: rgba(255, 255, 255, 0.03);
          border-radius: 20px;
          padding: 25px;
          border: 1px solid rgba(255, 140, 66, 0.1);
        }

        .secao-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .subtitulo {
          font-size: 1.4rem;
          color: #FF8C42;
          font-weight: 600;
        }

        .contador {
          background: rgba(255, 107, 0, 0.2);
          color: #FF8C42;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 500;
        }

        .lista {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .card {
          background: rgba(255, 255, 255, 0.05);
          padding: 18px;
          border-radius: 15px;
          border: 1px solid rgba(255, 140, 66, 0.1);
          transition: all 0.3s ease;
        }

        .card:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(255, 140, 66, 0.3);
          transform: translateX(5px);
        }

        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }

        .badge {
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 0.5px;
        }

        .badge-entrada {
          background: rgba(0, 184, 148, 0.2);
          color: #00b894;
        }

        .badge-saida {
          background: rgba(231, 76, 60, 0.2);
          color: #e74c3c;
        }

        .data {
          color: #888;
          font-size: 0.85rem;
        }

        .hora {
          color: #fff;
          font-size: 1.1rem;
          font-weight: 600;
        }

        .sem-registros {
          text-align: center;
          padding: 40px 20px;
          color: #666;
        }

        .sem-registros span {
          font-size: 3rem;
          display: block;
          margin-bottom: 10px;
          opacity: 0.5;
        }

        /* MODAL STYLES */
        .modal-bg {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.85);
          backdrop-filter: blur(5px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }

        .modal {
          background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
          padding: 30px;
          border-radius: 25px;
          width: 100%;
          max-width: 400px;
          border: 1px solid rgba(255, 107, 0, 0.3);
          box-shadow: 0 20px 40px rgba(255, 107, 0, 0.2);
        }

        .modal-header {
          text-align: center;
          margin-bottom: 25px;
        }

        .modal-header h3 {
          color: #FF8C42;
          font-size: 1.6rem;
          margin-bottom: 8px;
        }

        .modal-header p {
          color: #888;
          font-size: 0.95rem;
        }

        .upload-area {
          display: block;
          background: rgba(255, 255, 255, 0.05);
          border: 2px dashed rgba(255, 140, 66, 0.3);
          border-radius: 15px;
          padding: 40px 20px;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 20px;
        }

        .upload-area:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(255, 140, 66, 0.5);
        }

        .file-input {
          display: none;
        }

        .upload-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          color: #FF8C42;
        }

        .upload-icon {
          font-size: 2.5rem;
        }

        .preview-container {
          position: relative;
          margin-bottom: 20px;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5);
        }

        .preview {
          width: 100%;
          display: block;
          max-height: 250px;
          object-fit: cover;
        }

        .preview-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(255, 107, 0, 0.9);
          color: white;
          padding: 10px;
          text-align: center;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .modal-botoes {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .btn-confirmar {
          background: linear-gradient(135deg, #FF6B00, #FF8C42);
          color: white;
          border: none;
          padding: 16px;
          border-radius: 12px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .btn-confirmar:hover:not(:disabled) {
          background: linear-gradient(135deg, #FF8C42, #FF6B00);
          transform: translateY(-2px);
        }

        .btn-confirmar:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .btn-cancelar {
          background: transparent;
          color: #888;
          border: 1px solid rgba(255, 255, 255, 0.2);
          padding: 16px;
          border-radius: 12px;
          font-size: 1rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .btn-cancelar:hover:not(:disabled) {
          background: rgba(255, 255, 255, 0.05);
          color: #fff;
        }

        .loading-spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Responsividade */
        @media (max-width: 480px) {
          .container {
            padding: 15px;
          }
          
          .titulo {
            font-size: 1.8rem;
          }
          
          .botoes {
            grid-template-columns: 1fr;
          }
          
          .modal {
            padding: 25px 20px;
          }
        }
      `}</style>

    </div>
  );
}